export default {
  name: 'm-image-box',
  data() {
    return {
      naturalHeight: 0,
      naturalWidth: 0
    }
  },
  mounted() {
    const imgWrapper = this.$refs.imgWrapper;
    const { clientWidth, clientHeight } = imgWrapper;

    Object.assign(this, {
      clientHeight,
      clientWidth
    });
  },
  watch: {
    imgSrc: {
      handler: function (newVal, oldVal) {
        const img = new Image();
  
        img.src = newVal;
        img.onload = () => {
          const {naturalHeight, naturalWidth} = this.$refs.imgEle;

          this.$nextTick(() => {
            Object.assign(this, {
              naturalHeight,
              naturalWidth
            });
          });
        };
      },
      immediate: true
    }
  },
  methods: {
    handleMousedown (e) {
      this.mousedownForElement(e, this.element);
    },
    handleWrapperClick (e) {
      //e.stopPropagation();
      //e.preventDefault();
    },
    mousedownForElement (e) {
      const pos = { ...this.pos };
      const { clientWidth, clientHeight } = this;
      const imgEle = this.$refs.imgEle;
      const imageWidth = imgEle.clientWidth;
      const imageHeight = imgEle.clientHeight;
      let startY = e.clientY;
      let startX = e.clientX;
      let startTop = pos.top;
      let startLeft = pos.left;

      let move = moveEvent => {
        // 移动的时候，不需要向后代元素传递事件，只需要单纯的移动就OK
        moveEvent.stopPropagation();
        moveEvent.preventDefault();

        let currX = moveEvent.clientX;
        let currY = moveEvent.clientY;

        // 移动的时候不能超出图片的尺寸
        if (imageHeight > imageWidth) {
          const top = currY - startY + startTop;

          if (top > 0) {
            pos.top = 0;
          } else if (top + imageHeight < clientHeight) {
            pos.top = clientHeight - imageHeight;
          } else {
            pos.top = top;
          }
        } else {
          const left = currX - startX + startLeft;

          if (left > 0) {
            pos.left = 0;
          } else if (left + imageWidth < clientWidth) {
            pos.left = clientWidth - imageWidth;
          } else {
            pos.left = left;
          }
        }
        this.$emit('move', {
          value: { ...pos },
          pluginName: 'm-image-box'
        });
      }

      let up = moveEvent => {
        document.removeEventListener('mousemove', move, true);
        document.removeEventListener('mouseup', up, true);
      };

      document.addEventListener('mousemove', move, true);
      document.addEventListener('mouseup', up, true);
      return true;
    }
  },
  render() {
    const {
      bgImgSrc,
      padding,
      imgSrc,
      borderRadius,
      pos,
      naturalHeight,
      naturalWidth,
      backgroundColor
    } = this;
    // 比较图片的长宽，以最短的边来铺满容器
    let imgStandard = naturalHeight >= naturalWidth ? 'width' : 'height';
    const style = {
      backgroundImage: `url(${bgImgSrc})`,
      padding: padding.join(' '),
      backgroundSize: 'contain',
      backgroundColor,
      borderRadius
    };
    const imgWrapperStyle = {
      position: 'relative',
      overflow: 'hidden',
      height: '100%',
      borderRadius,
      transform: 'scale(1)',
      backgroundColor: 'transparent'
    };
    const imgStyle = {
      position: 'absolute',
      top: pos.top + 'px',
      left: pos.left + 'px',
      [imgStandard]: '100%'
    };
    const textStyle = {
      position: "absolute",
      width: "100px",
      display: "inline-block",
      height: "20px",
      color: "rgb(255, 117, 25)",
      fontSize: "15px",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: "auto"
    };

    return <div style={style}>
      <div
        ref="imgWrapper"
        style={imgWrapperStyle}>
        {
          !imgSrc ?
            <div style={{ ...imgWrapperStyle, backgroundColor: '#e3e3e3' }}>
              <span style={textStyle}>点击添加图片</span>
            </div> :
            <img
              ref="imgEle"
              onClick={this.handleWrapperClick}
              onMousedown={this.handleMousedown}
              src={imgSrc}
              style={imgStyle}/>
        }
      </div>
    </div>
  },
  props: {
    bgImgSrc: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: ''
    },
    padding: {
      type: Array,
      default: () => []
    },
    borderRadius: {
      type: String,
      default: ''
    },
    pos: {
      type: Object,
      default: () => { return { top: 0, left: 0 };}
    },
    showTip: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  editorConfig: {
    propsConfig: {
      bgImgSrc: {
        type: 'image-gallery',
        label: '图片url',
        prop: {
          type: 'textarea'
        },
        defaultPropValue: ''
      },
      imgSrc: {
        defaultPropValue: ''
      },
      padding: {
        defaultPropValue: []
      },
      borderRadius: {
        defaultPropValue: ''
      },
      pos: {
        defaultPropValue: {top: 0, left: 0}
      },
      showTip: {
        defaultPropValue: false
      },
      picInfo: {},
      backgroundColor: {
        defaultPropValue: 'transparent'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/album/plugins/m-image-box.js